<template>
  <SfButton
    :id="`${id}-icon-button`"
    :data-testid="`${id}-icon-button`"
    variant="tertiary"
    class="group/icon-button shadow-none hover:!shadow-none focus:!shadow-none"
    :class="[
      { relative: badgeContent },
      {
        'border border-neutral-300 hover:border-neutral-800 focus:border-neutral-800': border && type !== 'filled',
      },
      {
        'border border-neutral-200 hover:border-primary-400 focus:border-neutral-500': border && type === 'filled',
      },
      { 'bg-white hover:!bg-primary-400 disabled:!bg-neutral-200': type === 'filled' },
      { '!border-neutral-700': border && selected },
      { 'hover:!border-0 focus:!border-0': !border },
      { '!rounded-full': rounded },
    ]"
    square
  >
    <UiLoader v-if="isLoading" size="xs" />
    <component
      :is="icon"
      v-else
      :class="[
        iconClass,
        {
          'fill-white group-hover/icon-button:fill-neutral-100 group-focus/icon-button:fill-neutral-200':
            variant === 'primary',
        },
        {
          'fill-neutral-500 group-hover/icon-button:fill-neutral-600 group-focus/icon-button:fill-neutral-700':
            variant === 'secondary' && type === 'default',
        },
        {
          'fill-neutral-500 group-hover/icon-button:fill-neutral-100 group-focus/icon-button:fill-neutral-500':
            variant === 'secondary' && type === 'filled',
        },
        { '!fill-neutral-500': variant === 'secondary' && type === 'filled' && $attrs.disabled },
        { '!fill-neutral-700': selected },
        { '!fill-disabled-500': $attrs.disabled },
        { 'size-4': size === 'sm' },
        { 'size-6': size === 'base' },
        { 'size-8': size === 'lg' },
      ]"
    />
    <SfBadge
      v-if="badge"
      :id="`${id}-icon-button-badge`"
      :data-testid="`${id}-icon-button-badge`"
      :content="badgeContent"
      :variant="badgeContent ? 'standard' : 'dot'"
    />
  </SfButton>
</template>

<script setup lang="ts">
import type { IconButtonProps } from '~/components/ui/IconButton/types';

withDefaults(defineProps<IconButtonProps>(), { size: 'base', type: 'default', variant: 'primary' });
</script>
